import React from "react";

const Header = ({ title }) => {
  return (
    <div className="header">
      <p className="header-title">{title}</p>
      <div className="header-colors">
        <div className="header-colors-swatch">
          <span style={{ backgroundColor: "hsl(212, 95%, 92%)" }}></span>
          <p>0 - 100</p>
        </div>
        <div className="header-colors-swatch">
          <span style={{ backgroundColor: "hsla(212, 68%, 59%, 0.79)" }}></span>
          <p>101 - 199</p>
        </div>
        <div className="header-colors-swatch">
          <span style={{ backgroundColor: "hsl(212, 100%, 23%)" }}></span>
          <p>200 - 300</p>
        </div>
      </div>
    </div>
  );
};

export default Header;
